import type API from '@strim/gateway-api';
import type { SubscriptionsTypes } from '@strim/gateway-api';
import type { SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { useAuthToken } from '@rikstv/play-common/src/hooks/useAuthToken';

import { getCustomerSubscription } from '../../../../apis/StrimGatewayAPI';

/**
 * Gets customers subscription details
 *
 * Returns default `useSWR` responses
 */
export const useCustomerSubscription = (options?: Partial<SWRConfiguration>) => {
  const token = useAuthToken();

  const { data: subscription, ...rest } = useSWRImmutable(
    token ? ['gatewayApi.getCustomerSubscription', token] : null,
    async (): Promise<API.SubscriptionResponse> => getCustomerSubscription(token),
    { ...options }
  );
  return { subscription, ...rest };
};

export const HasActiveProducts = (
  subscription: API.SubscriptionResponse
): subscription is
  | SubscriptionsTypes.Active
  | SubscriptionsTypes.PendingCancellation
  | SubscriptionsTypes.PendingPaymentInfo
  | SubscriptionsTypes.PastDue
  | SubscriptionsTypes.PaymentInProgress
  | SubscriptionsTypes.UpgradeInProgress
  | SubscriptionsTypes.FreeAccess => {
  return [
    'Active',
    'PendingCancellation',
    'PendingPaymentInfo',
    'PastDue',
    'PaymentInProgress',
    'UpgradeInProgress',
    'FreeAccess',
  ].includes(subscription.state);
};
